import { canUseDOM } from 'exenv';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Sticky from 'react-stickynode';
import Waypoint from 'react-waypoint';
import striptags from 'striptags';
import get from 'lodash/get';
import extend from 'lodash/extend';
import findIndex from 'lodash/findIndex';
import chunk from 'lodash/chunk';
import concat from 'lodash/concat';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
import Social from '../../../../components/social/social';
import Slug from '../../../../components/slug/slug';
import Ad from '../../../../components/ad/ad';
import FCLink from '../../../../components/fc_link/fc_link';
import NotFound from '../../../../components/not_found_component/not_found_component';
import matchMediaDesktop from '../../../../../utils/client_util';
import loadDataYear from './mic_year_page_state_manager';
import loadDataSector from './mic_sector_page_state_manager';
import { RankedPagination } from '../../../../components/ranked';

class MicYear2019 extends Component {
  static loadData(store) {
    const navHist = get(store.getState(), 'config.navHistory');
    const sector =
      get(navHist, `[${navHist.length - 1}]`, '').indexOf('sectors') > -1;
    if (sector) {
      return loadDataSector(store, '2019');
    }
    return loadDataYear(store, '2019');
  }

  constructor() {
    super();
    this.state = {
      mobileTop50Active: false,
      mobileSectorsActive: false,
      mobileSocialActive: false,
      active: null,
      next: {},
      prev: {}
    };

    this.enbaleSticky = false;
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    this.toggleMobileShareButtons = this.toggleMobileShareButtons.bind(this);
  }

  componentDidMount() {
    this.html = document.querySelector('html');

    const adData = get(this.props.micYearPage, 'ads');

    if (canUseDOM) {
      if (adData !== undefined) {
        // Update the data layer
        extend(window.digitalData.page.pageInfo, {
          adPath: `/4160/mv.fc/${adData.model.adzone}`
        });
      }
    }
  }

  componentDidUpdate() {
    this.pageScrolling();
  }

  getArraySplit(arr, items) {
    return chunk(arr, Math.ceil(arr.length / items));
  }

  pad(n) {
    return n < 10 ? `0${n}` : n;
  }

  strip(str) {
    return striptags(str, [
      'a',
      'b',
      'em',
      'i',
      'u',
      'strike',
      'strong',
      'span'
    ]);
  }

  pageScrolling() {
    if (!this.html) return;
    const { mobileTop50Active, mobileSectorsActive } = this.state;
    const addRemove =
      mobileTop50Active || mobileSectorsActive ? 'add' : 'remove';
    this.html.classList[addRemove]('no-scroll');
  }

  toggleMobileMenu(isTop50) {
    const { mobileTop50Active, mobileSectorsActive } = this.state;
    this.setState({
      mobileTop50Active: isTop50 && !mobileTop50Active,
      mobileSectorsActive: !isTop50 && !mobileSectorsActive,
      mobileSocialActive: false
    });
  }

  closeMobileMenu() {
    this.setState({
      mobileTop50Active: false,
      mobileSectorsActive: false,
      mobileSocialActive: false
    });
  }

  toggleMobileShareButtons() {
    this.setState({
      mobileTop50Active: false,
      mobileSectorsActive: false,
      mobileSocialActive: !this.state.mobileSocialActive
    });
  }

  openCompanyInfoHeight(companyName) {
    const div = document.querySelector(`#${companyName}`);
    if (div.offsetHeight < 100) {
      return div.offsetHeight;
    }
    return div.scrollHeight;
  }

  openInfo(companyName) {
    if (companyName === this.state.active) {
      this.setState({ active: null });
    } else {
      this.setState({ active: companyName });
    }
  }

  scrollToRankPosition(rank) {
    const menu = document.querySelector('.mic-2019__honoree-menu');
    const company = document.querySelector(`#company-${rank}`);

    menu.classList.add('close');
    window.scroll({
      top: company.offsetTop - 100,
      left: 0,
      behavior: 'smooth'
    });
    setTimeout(() => {
      menu.classList.remove('close');
    }, 1000);

    this.closeMobileMenu();
  }

  scrollToCompany(rank) {
    const company = document.querySelector(`#company-${rank}`);

    if (company) {
      const offset = 102;
      window.scroll({
        top: company.offsetTop - offset,
        left: 0,
        behavior: 'smooth'
      });
    }
  }

  renderSectorPage(sector) {
    const { config, micSector } = this.props;
    const selectedSector = get(micSector, `[${this.activeIndex}]`, {});

    return (
      <section className="mic-year-page mic-year-page--2018">
        <Ad {...this.combinedAdModel} name="oop" slug={false} oop={true} />

        <div className="ad-container ad-container--gray ad-container--hide-for-small">
          <Ad {...this.combinedAdModel} name="flexiblebillboard_1" />
        </div>

        <div className="ad-container ad-container--hide-for-medium-up post__article-top-ad-wrapper">
          <Ad {...this.combinedAdModel} name="mobileleaderboard_short" />
        </div>

        <div className="mic-2019__sector">
          <div className="mic-2019__sector-social mic-2019__sector-social__desktop">
            <Social
              empty={false}
              enableSticky={false}
              modifier="mic-2019"
              uri={`https://www.fastcompany.com/most-innovative-companies/2019/sectors/${sector}`}
              text={{
                twitter: encodeURIComponent(
                  `The ${
                    selectedSector.name
                  } Honorees for @FastCompany's Most Innovative Companies 2019 #FCMostInnovative`
                ),
                linkedin: encodeURIComponent(
                  `The World's Most Innovative Companies 2019: ${
                    selectedSector.name
                  } Honorees.`
                ),
                email: encodeURIComponent(
                  `Meet FastCompany's Most Innovative Companies 2019`
                )
              }}
              subject={`Fast Company’s 50 Most Innovative Companies 2019: ${
                selectedSector.name
              } Honorees`}
            />
          </div>
          <div className="mic-2019__sector-content">
            <div className="mic-2019__sector-header">
              <img
                className="mic-2019__sector-header mic-2019__sector-header__desktop-image"
                src="https://images.fastcompany.net/image/upload/v1549570867/fcweb/MIC_WEB_banner_NEW_poxcsw.jpg"
                alt="2019 sector banner"
              />
              <img
                className="mic-2019__sector-header mic-2019__sector-header__mobile-image"
                src="https://images.fastcompany.net/image/upload/v1549576892/fcweb/MIC_mobile_honoreesbysector_1200x300_adlklp.jpg"
                alt="2019 sector banner"
              />
            </div>
            <Slug
              slugName={get(micSector, `[${this.activeIndex}].name`, '')}
              canUpdate={true}
            />
            <div className="mic-2019__sector-title">
              {get(micSector, `[${this.activeIndex}].name`, '').toUpperCase()}
            </div>
            <div className="mic-2019__sector-social mic-2019__sector-social__mobile">
              <Social
                empty={false}
                enableSticky={false}
                modifier="mic-2019"
                uri={`https://www.fastcompany.com/most-innovative-companies/2019/sectors/${sector}`}
                text={{
                  twitter: encodeURIComponent(
                    `The ${
                      selectedSector.name
                    } Honorees for @FastCompany's Most Innovative Companies 2019 #FCMostInnovative`
                  ),
                  linkedin: encodeURIComponent(
                    `The World's Most Innovative Companies 2019: ${
                      selectedSector.name
                    } Honorees.`
                  ),
                  email: encodeURIComponent(
                    `Meet FastCompany's Most Innovative Companies 2019`
                  )
                }}
                subject={`Fast Company’s 50 Most Innovative Companies 2019: ${
                  selectedSector.name
                } Honorees`}
              />
            </div>
            <div className="mic-2019__sector-group">
              <div className="mic-2019__sectors">
                {this.getArraySplit(micSector, 2).map((sectorsSplit, index) => (
                  <ul
                    key={`sector-page-list-${index}`}
                    className="mic-2019__list"
                  >
                    {sectorsSplit.map(sec => (
                      <li
                        key={`sector-page-item-${sec.url}`}
                        className={sector === sec.url ? 'active' : ''}
                      >
                        {sector === sec.url ? (
                          sec.name
                        ) : (
                          <a
                            href={`/most-innovative-companies/2019/sectors/${
                              sec.url
                            }`}
                          >
                            {sec.name}
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                ))}
              </div>
              <div className="mic-2019__sector-companies">
                {this.getArraySplit(micSector[this.activeIndex].list, 2).map(
                  (companies, splitIndex) => (
                    <div
                      key={`sector-page-rank-col-${splitIndex}`}
                      className="mic-2019__rank-col"
                    >
                      {companies.map((company, companyIndex) => (
                        <div
                          className="mic-2019__rank-company"
                          key={`${company.url}-${splitIndex}-${companyIndex}`}
                        >
                          <FCLink
                            config={config}
                            to={`/company/${company.url}`}
                          >
                            <span>
                              {this.pad(companyIndex + 1 + splitIndex * 5)}
                            </span>{' '}
                            <h2>{company.name}</h2>
                            <p>{company.for}</p>
                          </FCLink>
                        </div>
                      ))}
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="mic-2019__back-to-year">
          <a href="/most-innovative-companies/2019">
            BACK TO 50 most innovative companies
          </a>
        </div>
        <div className="ad-container">
          <Ad {...this.combinedAdModel} name="flexiblebillboard_2" />
          <Ad {...this.combinedAdModel} name="mobilerectangle_1" />
        </div>
        {this.renderMobileNav(sector)}
      </section>
    );
  }

  renderTop50() {
    const { micYear } = this.props;

    if (canUseDOM) {
      this.enbaleSticky = matchMediaDesktop();
    }

    return (
      <section className="mic-year-page mic-year-page--2018">
        <Ad {...this.combinedAdModel} name="oop" slug={false} oop={true} />

        <div className="ad-container ad-container--gray ad-container--hide-for-small">
          <Ad {...this.combinedAdModel} name="flexiblebillboard_1" />
        </div>

        <div className="ad-container ad-container--hide-for-medium-up post__article-top-ad-wrapper">
          <Ad {...this.combinedAdModel} name="mobileleaderboard_short" />
        </div>
        <div className="mic-2018__wrapper">
          {this.renderDesktopNav()}
          <div className="mic-2019__content-container">
            {micYear.map((compaines, yearIndex) => (
              <div className="mic-2018__group" key={`compaines-${yearIndex}`}>
                <div className="mic-2018__main-col">
                  {!yearIndex ? this.renderHeader() : null}
                  {this.renderCompanies(compaines)}
                </div>
                <div
                  className="mic-2018__sidebar"
                  id={`mic-2018-sidebar-${yearIndex}`}
                >
                  {/* eslint-disable no-nested-ternary */}
                  <Sticky
                    top={100}
                    bottomBoundary={`#mic-2018-sidebar-${yearIndex}`}
                    enabled={this.enbaleSticky}
                  >
                    <Ad
                      {...this.combinedAdModel}
                      pos="atf"
                      name="flexibleportrait"
                      canRefresh={true}
                      pageNum={1}
                    />
                  </Sticky>
                </div>
              </div>
            ))}
          </div>
          {this.renderHonorees()}
        </div>
        <div className="ad-container">
          <Ad {...this.combinedAdModel} name="flexiblebillboard_2" />
          <Ad {...this.combinedAdModel} name="mobilerectangle_1" />
        </div>
        {this.renderMobileNav()}
      </section>
    );
  }

  renderDesktopNav() {
    const { config, micYear, micSector } = this.props;
    const firstSector = get(micSector, '[0]', {});

    return (
      <div className="mic-2019__nav" id="mic-2019-nav">
        {/* eslint-disable no-nested-ternary */}
        <Sticky
          top={120}
          bottomBoundary="#mic-2019-nav"
          enabled={this.enbaleSticky}
        >
          <Social
            empty={false}
            enableSticky={false}
            modifier="mic-2018"
            uri="https://www.fastcompany.com/most-innovative-companies/2019/"
            text={{
              twitter: encodeURIComponent(
                `Meet @FastCompany's Most Innovative Companies 2019 #FCMostInnovative`
              ),
              linkedin: encodeURIComponent(
                `Meet FastCompany's Most Innovative Companies 2019`
              ),
              email: encodeURIComponent(
                `Meet FastCompany's Most Innovative Companies 2019`
              )
            }}
            subject="Fast Company’s 50 Most Innovative Companies of 2019."
          />

          <div className="mic-2019__honoree-menu">
            <span>Honorees By Rank</span>
            <div className="mic-2019__honoree-menu-panel">
              {this.getArraySplit(concat(...micYear), 3).map(
                (rankSplit, index) => (
                  <ul key={`company-rank-list-${index}`}>
                    {rankSplit.map(company => (
                      <li
                        key={`company-rank-${company.ranking}`}
                        onClick={() =>
                          this.scrollToRankPosition(company.ranking)
                        }
                      >
                        <span>{this.pad(company.ranking)}</span> {company.name}
                      </li>
                    ))}
                  </ul>
                )
              )}
            </div>
          </div>
          <FCLink
            config={config}
            to={`/most-innovative-companies/2019/sectors/${firstSector.url}`}
            className="mic-2019__honoree-by-sector"
          >
            Honorees By Sector
          </FCLink>
          <a
            href="https://www.fastcompany.com/apply/most-innovative-companies"
            className="mic-2018__apply"
          >
            APPLY FOR MIC
          </a>
        </Sticky>
        <RankedPagination
          {...this.state}
          scrollTo={this.scrollToCompany}
          pad={this.pad}
          mic={true}
        />
      </div>
    );
  }

  renderMobileNav(sector) {
    const { config, micYear, micSector } = this.props;

    const {
      mobileTop50Active,
      mobileSectorsActive,
      mobileSocialActive
    } = this.state;
    const top50 = concat(...micYear);
    const rankLink = () => {
      if (sector) {
        return (
          <div className="mic-2018__mobile-item">
            <FCLink config={config} to="/most-innovative-companies/2019">
              Top 50
            </FCLink>
          </div>
        );
      }

      return (
        <div
          className="mic-2018__mobile-item"
          onClick={() => this.toggleMobileMenu(true, mobileTop50Active, false)}
        >
          Top 50
        </div>
      );
    };
    const sectorLink = () => (
      <div
        className="mic-2018__mobile-item"
        onClick={() => this.toggleMobileMenu(false, false, mobileSectorsActive)}
      >
        TOP 10<span>s</span>
      </div>
    );
    const closeBtn = () => (
      <div
        className="mic-2019__mobile-close"
        onClick={() => this.closeMobileMenu()}
      />
    );

    return (
      <div className="mic-2018__mobile-nav">
        <div className="mic-2018__mobile-item-container">
          {rankLink()}
          {sectorLink()}
          <div
            className="mic-2018__mobile-item mic-2018__mobile-item--share"
            onClick={() => this.toggleMobileShareButtons()}
          >
            <i className="icon-video-share" />
          </div>
        </div>
        <div
          className={`mic-2019__mobile-list ${
            mobileTop50Active ? 'mic-2019__mobile-list--active' : ''
          }`}
        >
          <h3 className="mic-2019__mobile-title">
            Most Innovative Companies 2019
          </h3>
          {closeBtn()}
          <ul
            className={`mic-2019__list ${
              mobileTop50Active ? 'mic-2019__list--active' : ''
            }`}
          >
            <img
              src="https://images.fastcompany.net/image/upload/v1550783869/fcweb/MIC_mobile_honoreesbysector_extrasquiggle_oez8qv.jpg"
              alt="mic logo"
            />
            {top50.map(company => (
              <li
                key={`mobile-nav-50-${company.url}`}
                onClick={() => this.scrollToRankPosition(company.ranking)}
              >
                <span>{this.pad(company.ranking)}</span> {company.name}
              </li>
            ))}
          </ul>
        </div>

        <div
          className={`mic-2019__mobile-list ${
            mobileSectorsActive ? 'mic-2019__mobile-list--active' : ''
          }`}
        >
          <h3 className="mic-2019__mobile-title">
            Most Innovative Companies 2019
          </h3>
          {closeBtn()}
          <ul
            className={`mic-2019__list ${
              mobileSectorsActive ? 'mic-2019__list--active' : ''
            }`}
          >
            <img
              src="https://images.fastcompany.net/image/upload/v1550783869/fcweb/MIC_mobile_honoreesbysector_extrasquiggle_oez8qv.jpg"
              alt="mic logo"
            />
            {micSector.map(sec => (
              <li
                key={`mobile-nav-sector-${sec.url}`}
                onClick={() => this.closeMobileMenu()}
              >
                <FCLink
                  config={config}
                  to={`/most-innovative-companies/2019/sectors/${sec.url}`}
                >
                  {sec.name}
                </FCLink>
              </li>
            ))}
          </ul>
        </div>

        <div
          className={`mic-2018__mobile-social ${
            mobileSocialActive ? 'mic-2018__mobile-social--active' : ''
          }`}
        >
          <Social
            empty={false}
            enableSticky={false}
            modifier="mic-2019"
            uri="https://www.fastcompany.com/most-innovative-companies/2019/"
            text={{
              twitter: encodeURIComponent(
                `Meet @FastCompany's Most Innovative Companies 2019 #FCMostInnovative`
              ),
              linkedin: encodeURIComponent(
                `Meet FastCompany's Most Innovative Companies 2019`
              ),
              email: encodeURIComponent(
                `Meet FastCompany's Most Innovative Companies 2019`
              )
            }}
            subject="Fast Company’s 50 Most Innovative Companies of 2019."
          />
        </div>
      </div>
    );
  }

  renderHeader() {
    const { micYearDescription } = this.props;

    return (
      <div className="mic-2019__header">
        <Waypoint
          onEnter={() => {
            this.setState({
              prev: {},
              next: {}
            });
          }}
        />
        <img
          className="mic-2019__header__desktop-image"
          src="https://images.fastcompany.net/image/upload/v1549659061/fcweb/MIC_OpenerGraphic_DESKTOP_lak2em.jpg"
          alt={micYearDescription.description}
        />
        <img
          className="mic-2019__header__mobile-image"
          src="https://images.fastcompany.net/image/upload/v1549659061/fcweb/MIC_OpenerGraphic_MOBILE_r70ri7.jpg"
          alt={micYearDescription.description}
        />
        <div
          className="mic-2019__header__text"
          dangerouslySetInnerHTML={{
            __html: micYearDescription.intro
          }}
        />
      </div>
    );
  }

  renderCompanies(compaines) {
    const { config } = this.props;
    return (
      <div className="mic-2019__companies">
        {compaines.map((company, index) => (
          <React.Fragment>
            <Waypoint
              onEnter={() => {
                // console.log("Index",this.props.micYear[this.props.micYear.indexOf(compaines)+1][0])
                if (index === 0) {
                  this.setState({
                    prev: this.props.micYear[
                      this.props.micYear.indexOf(compaines) - 1
                    ][9],
                    next: compaines[index + 1]
                  });
                } else {
                  this.setState({
                    prev: compaines[index - 1],
                    next:
                      index === 9
                        ? this.props.micYear[
                            this.props.micYear.indexOf(compaines) + 1
                          ][0]
                        : compaines[index + 1]
                  });
                }
              }}
            />
            <div
              key={`company-${company.ranking}`}
              id={`company-${company.ranking}`}
              className={`mic-2019__company ${
                company.media && company.media_orientation === 'landscape'
                  ? 'mic-2019__company--landscape'
                  : ''
              }`}
            >
              <div className="mic-2019__company-info">
                <FCLink config={config} to={`/company/${company.url}`}>
                  <span className="mic-2019__company__ranking">
                    {`${this.pad(company.ranking)} `}
                  </span>{' '}
                  <h3 className="mic-2019__company__name">{company.name}</h3>
                </FCLink>
                {company.media ? (
                  <p className="mic-2019__why">{company.why}</p>
                ) : null}
                {!company.media ||
                (company.media && company.media_orientation === 'portrait') ? (
                  <ul className="mic-2019__company__links">
                    <li className="mic-2019__company__links__profile">
                      <FCLink config={config} to={`/company/${company.url}`}>
                        COMPANY PROFILE
                      </FCLink>
                    </li>
                    {company.related_article ? (
                      <li className="mic-2019__company__links__article">
                        <FCLink config={config} to={company.related_article}>
                          READ ARTICLE
                        </FCLink>
                      </li>
                    ) : null}
                  </ul>
                ) : null}
              </div>
              <div className="mic-2019__company-content">
                {company.media ? (
                  [
                    <img src={company.media} alt={company.caption} />,
                    // <Image
                    //   key={`image-${company.url}`}
                    //   src={company.media}
                    //   alt={company.caption}
                    //   assetSizes={imageSizesLookup.mic2018Landscape}
                    //   noLazy={true}
                    // />,
                    <p
                      key={`caption-${company.url}`}
                      className="mic-2019__caption"
                      dangerouslySetInnerHTML={{
                        __html: this.strip(
                          `${company.caption} [${company.credits}]`
                        )
                      }}
                    />
                  ]
                ) : (
                  <p className="mic-2019__why mic-2019__why--inline">
                    {company.why}
                  </p>
                )}
                {company.media && company.media_orientation === 'landscape' ? (
                  <ul className="mic-2019__company__links">
                    <li className="mic-2019__company__links__profile">
                      <FCLink config={config} to={`/company/${company.url}`}>
                        COMPANY PROFILE
                      </FCLink>
                    </li>
                    {company.related_article ? (
                      <li className="mic-2019__company__links__article">
                        <FCLink config={config} to={company.related_article}>
                          READ ARTICLE
                        </FCLink>
                      </li>
                    ) : null}
                  </ul>
                ) : null}
                <div className="mic-2019__reason" id={company.name}>
                  {
                    <p
                      className="mic-2019__reason"
                      dangerouslySetInnerHTML={{
                        __html: this.strip(company.summary)
                      }}
                    />
                  }
                  <a href={company.related_article}>
                    {company.read_more_text === null ||
                    company.read_more_text === ''
                      ? 'READ MORE'
                      : company.read_more_text}
                  </a>
                </div>
              </div>
            </div>

            <Waypoint
              onEnter={() => {
                if (company.ranking === 50) {
                  this.setState({
                    prev: {},
                    next: {}
                  });
                }
              }}
            />
          </React.Fragment>
        ))}
      </div>
    );
  }

  renderHonorees() {
    const { config, micSector } = this.props;
    const firstSector = get(micSector, '[0]', {});

    return (
      <div className="mic-2019__honorees-by-sectors">
        <div className="mic-2019__sector-header">
          <h1>
            <FCLink
              config={config}
              to={`/most-innovative-companies/2019/sectors/${firstSector.url}`}
            >
              <img
                src="https://images.fastcompany.net/image/upload/v1549570205/fcweb/MIC_WEB_banner_wider_NEW_t54jb2.jpg"
                alt="2019 sector banner"
              />
            </FCLink>
          </h1>
        </div>
        {this.getArraySplit(micSector, 4).map((sectorsSplit, index) => (
          <ul key={`sectors-list-${index}`}>
            {sectorsSplit.map(sec => (
              <li key={`sector-${sec.url}`}>
                <FCLink
                  config={config}
                  to={`/most-innovative-companies/2019/sectors/${sec.url}`}
                >
                  {sec.name.toUpperCase()}
                </FCLink>
              </li>
            ))}
          </ul>
        ))}
      </div>
    );
  }

  render() {
    const { match, status, micYearPage, micSector } = this.props;
    const sector = get(match, 'params.sector');

    this.activeIndex = -1;

    if (sector) {
      this.activeIndex = findIndex(micSector, sec => sec.url === sector);
    }

    if (
      this.props.micYearPage.error ||
      status === 404 ||
      (sector && this.activeIndex < 0)
    ) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.micYearPage.isLoading === false) {
      const adData = get(micYearPage, 'ads');
      this.combinedAdModel = extend(
        {},
        { baseConfig: get(adData, 'config.baseConfig') },
        { definitions: get(adData, 'config.definitions') },
        { model: get(adData, 'model') }
      );

      if (sector) {
        return this.renderSectorPage(sector);
      }

      return this.renderTop50();
    }

    return <LoadingSpinner />;
  }
}

function mapStateToProps(state = {}) {
  const micData = chunk(get(state, 'micYear.data.rows'), 10);
  const micYearDesc = get(state, 'micYearDescription.data.rows[0]');
  return {
    config: state.config || {},
    status: state.status.code,
    micYearPage: Object.keys(get(state, 'micYearPage')).length
      ? state.micYearPage
      : get(state, 'micSectorPage') || { error: true },
    micYear: micData || { error: true },
    year: get(state, 'micYear.year'),
    micSector: get(state, 'micSector.data.rows', []),
    micYearDescription: micYearDesc || { error: true }
  };
}

MicYear2019.propTypes = {
  config: PropTypes.shape({}).isRequired,
  status: PropTypes.number,
  match: PropTypes.shape({}).isRequired,
  micYearPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }),
  year: PropTypes.string,
  micYear: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired,
  micYearDescription: PropTypes.shape({
    logo_url: PropTypes.string,
    intro: PropTypes.string
  }),
  micSector: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

MicYear2019.defaultProps = {
  status: 200,
  micYearPage: PropTypes.shape({
    isLoading: false,
    error: false,
    errorMessage: 'Error in micYearPage Props'
  }),
  year: '',
  micYearDescription: PropTypes.shape({
    logo_url: '',
    intro: ''
  })
};

export default withRouter(connect(mapStateToProps)(MicYear2019));
